<pre id="jsonstring"></pre>

<button cButton (click)="routerTest()">RouteTest</button>
